const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/';
// const baseUrl = 'https://api.edjobster.com/';

const apiUrl = {
  signIn: `${baseUrl}account/sign-in/`,
  forgotPasswords: `${baseUrl}account/forgot-password/`,
  resetPasswords: `${baseUrl}account/reset-password/`,
  changePasswords: `${baseUrl}account/change-password/`,
  department: `${baseUrl}settings/department/`,
  degree: `${baseUrl}settings/degree/`,
  allCompanies:`${baseUrl}account/get-all-company/`,
  usercompanies:`${baseUrl}account/get-company/`,
  designation: `${baseUrl}settings/designation/`,
  companyInfo: `${baseUrl}account/company-info/`,
  // companyLogo: `${baseUrl}account/company-logo/`,
  country: `${baseUrl}common/countires/`,
  state: `${baseUrl}common/states/?id=`,
  city: `${baseUrl}common/cities/?id=`,
  address: `${baseUrl}settings/location/`,
  testimonials: `${baseUrl}settings/testimonials/`,
  user: `${baseUrl}account/members/`,
  companyUser: `${baseUrl}account/company-members/`,
  CaptureLeads: `${baseUrl}account/lead/list/`,
  userUpdate: `${baseUrl}account/update-account/`,
  userPhoto: `${baseUrl}account/member-photo/`,
  activateUser: `${baseUrl}account/activate-member/`,
  deleteUser: `${baseUrl}account/members/`,
  userRole: `${baseUrl}account/member-role/`,
  leadCapture: `${baseUrl}account/lead/capture/`,
  leadVerify: `${baseUrl}account/lead/verify/`,
  leadCreateTrialUser: `${baseUrl}account/lead/create-trial-user/`,
  stage: `${baseUrl}settings/pipeline-stage/`,
  jobAssociatePipelineStage: `${baseUrl}settings/job-associate-pipeline-stages/`,
  status: `${baseUrl}settings/pipeline-detalis/`,
  pipeline: `${baseUrl}settings/pipeline/`,
  emailtamplate: `${baseUrl}settings/email-template/`,
  emailVariables: `${baseUrl}settings/email-field/`,
  modules: `${baseUrl}settings/module/`,
  modulestypes: `${baseUrl}settings/moduletypes/`,
  modulescompany: `${baseUrl}settings/modulecompany`,
  webform: `${baseUrl}settings/webform/`,
  assementCategory: `${baseUrl}jobs/assesment-category/`,
  assesment:`${baseUrl}jobs/assesment/`,
  assesmentFilter:`${baseUrl}jobs/assessment_query/`,
  assesmentQuestions: `${baseUrl}jobs/assesment-question/`,
  jobs: `${baseUrl}jobs/`,
  jobApplications: `${baseUrl}jobs/job-candidates/`,  
  candidate:`${baseUrl}candidate/`,
  createCandidateWithResume: `${baseUrl}candidate/create-candidates/`,
  parseResume: `${baseUrl}candidate/resume-parse/`, 
  skill:`${baseUrl}candidate/skill/`,         
  subject:`${baseUrl}candidate/subject-specialization/`,          
  interviewSchedule:`${baseUrl}interview/interviews-schedule/`,
  interview:`${baseUrl}interview/interviews/`,
  interviews:`${baseUrl}interview/`,
  interviewDetails:`${baseUrl}interview/interviews/`,
  interviewQuery:`${baseUrl}interview/interviewquery/`,
  jobsInterview:`${baseUrl}interview/JobInterviewDetails/`,
  candidatesInterview:`${baseUrl}interview/candidateInterviewDetails/`,
  latest_interview: `${baseUrl}interview/interview-latest/`,
  // Interview public endpoints
  interviewRescheduleCreate: `${baseUrl}interview/interviews/`, // + <id>/reschedule/
  interviewRescheduleUpdate: `${baseUrl}interview/reschedule/`, // + <pk>/
  interviewRescheduleAction: `${baseUrl}interview/reschedule-action/`, // + <pk>/
  interviewFeedback: `${baseUrl}interview/interviews/`, // + <id>/feedback/
  interviewICS: `${baseUrl}interview/interviews/`, // + <id>/ics/
  // Headless public endpoints
  headlessValidate: `${baseUrl}interview/headless/validate/`, // + <token>/
  headlessAction: `${baseUrl}interview/headless/action/`, // + <token>/
  location:`${baseUrl}settings/location/`,  
  notes: `${baseUrl}candidate/notes/`,
  job_notes: `${baseUrl}jobs/job-notes/`,
  tasks:`${baseUrl}candidate/task/`,
  addTasks:`${baseUrl}candidate/tasks/`,
  taskOptionsList:`${baseUrl}candidate/tasks-options/`,
  events:`${baseUrl}candidate/events/`,
  eventOptionsList:`${baseUrl}candidate/events-options/`,
  calls:`${baseUrl}candidate/calls/`,
  callOptionsList:`${baseUrl}candidate/calls-options/`,
  addTasksJob:`${baseUrl}jobs/tasks/`,
  taskOptionsListJob:`${baseUrl}jobs/tasks-options/`,
  eventsJob:`${baseUrl}jobs/events/`,
  eventOptionsListJob:`${baseUrl}jobs/events-options/`,
  callsJob:`${baseUrl}jobs/calls/`,
  callOptionsListJob:`${baseUrl}jobs/calls-options/`,
  tasksList:`${baseUrl}candidate/task-by-candidate/`,
  notesType:`${baseUrl}common/note-types/`,
  signUp: `${baseUrl}account/sign-up/`,
  approveUser: `${baseUrl}account/approve/`,
  candidateMail:`${baseUrl}common/candidate-mail/`,
  common: `${baseUrl}common/`,
  settings: `${baseUrl}settings/`,
  contacts: `${baseUrl}settings/contacts/`,
  companyAdd:`${baseUrl}account/add-company/`,
  careerSiteCompanyData: `${baseUrl}account/careersite-company-details/`,
  userVerifyAccount: `${baseUrl}account/activate/?token=`,
  emailSettingSmtp: `${baseUrl}candidate/email_setting_smtp/`,
  billingPlan: `${baseUrl}settings/billing-plan/`,
  createOrder: `${baseUrl}settings/create_order/`,
  paymentSuccess: `${baseUrl}settings/payment_success/`,
  trialUsers: `${baseUrl}account/trial-users/`,
  currentSubscription: `${baseUrl}settings/current_subscription_plan/`,
  candidateGenerateExtractResume: `${baseUrl}candidate/generate-extract/`,
  candidateTimeline:`${baseUrl}candidate/candidate-timeline/`,
  jobTimeline:`${baseUrl}jobs/job-timeline/`,
  assignJobToCandidates:`${baseUrl}candidate/assign-job-to-candidates/`,
  ai: `${baseUrl}jobs/ai/`,

  evaluationCriteria:`${baseUrl}settings/evaluation-criteria/`
};

export { baseUrl, apiUrl };
